import { SERVICES } from "@/constants/clinic";

export const Services = () => (
  <section id="services" className="py-20 lg:py-28">
    <div className="max-w-7xl mx-auto px-6">
      <p className="text-sm font-semibold uppercase tracking-widest text-secondary">Specialties</p>
      <h2 className="mt-3 text-2xl sm:text-3xl lg:text-4xl font-semibold tracking-tight text-[#1A252C] max-w-2xl">Care for the conditions that matter most to your daily health</h2>
      <div className="mt-12 grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {SERVICES.map(({ icon: Icon, title, text, featured }, i) => (
          <div
            key={title}
            data-testid={`service-card-${i}`}
            className={`group rounded-3xl p-8 border transition-transform duration-300 hover:-translate-y-1 ${featured ? "bg-primary text-white border-primary" : "bg-white border-slate-100 hover:border-secondary/40"}`}
          >
            <span className={`h-12 w-12 rounded-2xl grid place-items-center ${featured ? "bg-white/15" : "bg-accent text-primary"}`}><Icon className="h-6 w-6" /></span>
            <div className="mt-6">
              <h3 className={`text-xl font-semibold ${featured ? "text-white text-2xl" : "text-[#1A252C]"}`}>{title}</h3>
              <p className={`mt-3 text-sm leading-relaxed ${featured ? "text-white/80" : "text-muted-foreground"}`}>{text}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
);
